var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAll = function SvgAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.701.792 1.954 4.954L14.609 7.7 9.655 9.654 7.7 14.608 5.747 9.654.793 7.7l4.954-1.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m18.391 7.353 1.02 2.588L22 10.96l-2.587 1.02-1.02 2.588-1.021-2.587-2.588-1.02 2.588-1.021zM12.76 15.664l.896 2.272 2.272.896-2.272.896L12.76 22l-.896-2.272-2.272-.896 2.272-.896z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgAll;